import { MainStoreState } from "./MainStore.types";

export const mainStoreState: MainStoreState = {
  loading: false,
  error: false,
}